import EquipmentSelection from './EquipmentSelection'
import equipmentSelectionContainer from './equipmentSelectionContainer'

export default equipmentSelectionContainer(EquipmentSelection)
